import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkspaceEditingService = ( createDecorator('workspaceEditingService'));
export { IWorkspaceEditingService };
